import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function ComparisonCharts({ selected1, selected2, comparisonResults }) {
  if (!selected1 || !selected2) {
    return null;
  }
  
  // Prepare data for Elo comparison chart
  const prepareEloComparisonData = () => {
    return [
      {
        stat: "Elo Général",
        [selected1.player]: selected1.elo,
        [selected2.player]: selected2.elo
      },
      {
        stat: "Elo Dur",
        [selected1.player]: selected1.helo,
        [selected2.player]: selected2.helo
      },
      {
        stat: "Elo Terre Battue",
        [selected1.player]: selected1.celo,
        [selected2.player]: selected2.celo
      },
      {
        stat: "Elo Gazon",
        [selected1.player]: selected1.gelo,
        [selected2.player]: selected2.gelo
      }
    ];
  };
  
  // Prepare data for surface probabilities comparison chart
  const prepareMultiSurfaceComparisonData = () => {
    if (!comparisonResults) return null;
    
    return [
      {
        surface: "Dur",
        [selected1.player]: comparisonResults.hard.advanced.player1,
        [selected2.player]: comparisonResults.hard.advanced.player2,
      },
      {
        surface: "Terre Battue",
        [selected1.player]: comparisonResults.clay.advanced.player1,
        [selected2.player]: comparisonResults.clay.advanced.player2,
      },
      {
        surface: "Gazon",
        [selected1.player]: comparisonResults.grass.advanced.player1,
        [selected2.player]: comparisonResults.grass.advanced.player2,
      }
    ];
  };
  
  return (
    <div>
      {/* Graphique de comparaison des Elos par surface */}
      <div style={{marginBottom: 25}}>
        <h4 style={{marginBottom: 10}}>Comparaison des Elos par surface</h4>
        <div style={{height: 300}}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={500}
              height={300}
              data={prepareEloComparisonData()}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="stat" />
              <YAxis domain={[1500, 2400]} />
              <Tooltip />
              <Legend />
              <Bar dataKey={selected1.player} fill="#8884d8" radius={[10, 10, 0, 0]} />
              <Bar dataKey={selected2.player} fill="#82ca9d" radius={[10, 10, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      
      {/* Graphique de comparaison des probabilités sur toutes les surfaces */}
      {comparisonResults && (
        <div style={{marginBottom: 25}}>
          <h4 style={{marginBottom: 10}}>Probabilités de victoire par surface</h4>
          <div style={{height: 300}}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                width={500}
                height={300}
                data={prepareMultiSurfaceComparisonData()}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="surface" />
                <YAxis domain={[0, 100]} />
                <Tooltip formatter={(value) => `${value}%`} />
                <Legend />
                <Bar dataKey={selected1.player} fill="#8884d8" radius={[10, 10, 0, 0]} />
                <Bar dataKey={selected2.player} fill="#82ca9d" radius={[10, 10, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
      
      {/* Affichage des valeurs Elo pour chaque joueur */}
      <div style={{display: "flex", gap: 20, marginBottom: 20}}>
        <div style={{flex: 1}}>
          <p><b>{selected1.player}</b></p>
          <ul style={{listStyle: 'none', padding: 0}}>
            <li>Elo général : {selected1.elo}</li>
            <li>Elo dur : {selected1.helo}</li>
            <li>Elo terre battue : {selected1.celo}</li>
            <li>Elo gazon : {selected1.gelo}</li>
          </ul>
        </div>
        <div style={{flex: 1}}>
          <p><b>{selected2.player}</b></p>
          <ul style={{listStyle: 'none', padding: 0}}>
            <li>Elo général : {selected2.elo}</li>
            <li>Elo dur : {selected2.helo}</li>
            <li>Elo terre battue : {selected2.celo}</li>
            <li>Elo gazon : {selected2.gelo}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ComparisonCharts; 